import { useMemo } from 'react'
import type { JSX } from 'react'

import { Button, Flex, Heading, Link, Paragraph } from '@buffer-mono/popcorn'

import { FeedbackWidget } from '~publish/components/FeedbackWidget'
import { useSelectedChannel } from '~publish/pages/Channel/ChannelContext'

import commonStyles from '../../../../GeneralSettings.module.css'
import { BulkPostDialog } from '../BulkPostDialog'

import styles from './BulkPostSetting.module.css'

export const BULK_UPLOAD_EXCLUDED_SERVICES = ['youtube']

export const BulkPostSetting = (): JSX.Element | null => {
  const channel = useSelectedChannel()

  const description = useMemo(() => {
    if (channel?.service === 'youtube') {
      return 'This feature currently only supports images, so YouTube is not supported at the moment.'
    }

    return (
      <>
        Schedule multiple posts in bulk by uploading a CSV file.
        <br />
        This is an early beta feature, and we’re actively working on improving
        it.{' '}
        <FeedbackWidget id="bulk-post-upload-1" source="publish">
          <Link as="button" className={styles.shareFeedbackButton}>
            Share feedback
          </Link>
        </FeedbackWidget>
      </>
    )
  }, [channel?.service])

  return (
    <Flex direction="column" fullWidth className={commonStyles.row} gap="xl">
      <Flex direction="column" gap="xs">
        <Heading size="small" as="h3">
          Bulk Post Upload
        </Heading>
        <Paragraph color="subtle">{description}</Paragraph>
      </Flex>
      <Flex
        as="section"
        justify="between"
        className={commonStyles.actionsWrapper}
      >
        {!BULK_UPLOAD_EXCLUDED_SERVICES.includes(channel?.service) && (
          <BulkPostDialog key="csv-uploader">
            <Button
              variant="secondary"
              size="large"
              className={styles.openDialogButton}
            >
              Bulk Upload
            </Button>
          </BulkPostDialog>
        )}
      </Flex>
    </Flex>
  )
}
